module.exports = __webpack_public_path__ + "static/media/7680x4320.489566b5.jpg";